import { useFormik } from "formik";
import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "ui/atoms/TextField";
import Button from "@mui/material/Button";
import MultipleSelectChip from "ui/organisms/MultipleSelectChip";
import { Link } from "react-router-dom";
import BusinessSelection from "./components/BusinessSelection";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { getGroups, getBusinessUnit, userPayloadMapper, userValidationSchema } from "lib/helpers/userHelper";

const UserForm = ({
  user,
  groups,
  loading,
  IsEdition,
  businesses,
  handleSubmit,
  groupSelected,
  submitButtonText,
  setGroupSelected,
  businessesSelected,
  setBusinessesSelected,
}: any) => {
  const userBusinessUnits = user?.userBusinessUnits ?? [];
  const formik = useFormik({
    enableReinitialize: true,
    //validateOnChange: true,
    initialValues: {
      name: user?.name || "",
      email: user?.eMail || "",
      businesses: getBusinessUnit(user?.userBusinessUnits)[0] || "",
      groupMembers: getGroups(user?.groupMembers),
      allBusinessSelected: false,
    },
    validationSchema: userValidationSchema,
    onSubmit: (values) => {
      const payload = userPayloadMapper({
        user,
        values,
        IsEdition,
        groupSelected,
        businessesSelected,
      });
      handleSubmit(payload);
    },
  });
  const tableRows = [
    { name: "Sede", isVisible: true },
    { name: "Acciones", isVisible: true },
  ];
  return (
    <Box
      component='form'
      sx={{
        width: 600,
        margin: "auto",
        maxWidth: "100%",
      }}
      noValidate
      autoComplete='off'
      onSubmit={formik.handleSubmit}
    >
      <TextField
        id='name'
        name='name'
        label='Nombre'
        margin='normal'
        inputProps={{ maxLength: 50 }}
        value={formik.values.name}
        onChange={formik.handleChange}
        error={formik.touched.name && Boolean(formik.errors.name)}
        helperText={formik.touched.name && formik.errors.name}
      />
      <TextField
        id='email'
        name='email'
        margin='normal'
        label='Correo electrónico'
        value={formik.values.email}
        onChange={formik.handleChange}
        error={formik.touched.email && Boolean(formik.errors.email)}
        helperText={formik.touched.email && formik.errors.email}
      />
      <BusinessSelection
        margin='normal'
        formik={formik}
        id='businesses'
        name='businesses'
        tableRows={tableRows}
        businesses={businesses}
        label='Seleccione las sedes'
        checkboxName='allBusinessSelected'
        userBusinessUnits={userBusinessUnits}
        businessesSelected={businessesSelected}
        setBusinessesSelected={setBusinessesSelected}
      />
      <MultipleSelectChip
        formik={formik}
        keyToMap='name'
        id='groupMembers'
        name='groupMembers'
        dataSourse={groups}
        label='Asignar Grupos'
        value={formik.values.groupMembers}
        setItemSelected={setGroupSelected}
        error={formik.touched.groupMembers && Boolean(formik.errors.groupMembers)}
        helperText={formik.touched.groupMembers && formik.errors.groupMembers}
      />
      <ButtonContainer>
        <Link to='/admin/users'>
          <Button type='button'>Volver</Button>
        </Link>
        <LoadingButton
          size='small'
          type='submit'
          loading={loading}
          loadingPosition='start'
          startIcon={<SaveIcon />}
          disabled={loading}
        >
          <span>{submitButtonText}</span>
        </LoadingButton>
      </ButtonContainer>
    </Box>
  );
};

export default UserForm;

const ButtonContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(2, 0)};
`;
